const IndexTypeIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      d="M9.32415 16.2234C9.23487 15.8773 9.05448 15.5615 8.80176 15.3088C8.54904 15.0561 8.23322 14.8757 7.88715 14.7864L1.75215 13.2044C1.64748 13.1747 1.55536 13.1116 1.48976 13.0248C1.42416 12.938 1.38867 12.8322 1.38867 12.7234C1.38867 12.6146 1.42416 12.5088 1.48976 12.4219C1.55536 12.3351 1.64748 12.2721 1.75215 12.2424L7.88715 10.6594C8.2331 10.5702 8.54884 10.39 8.80155 10.1374C9.05426 9.8849 9.23471 9.56928 9.32415 9.22339L10.9061 3.08839C10.9356 2.98331 10.9985 2.89074 11.0855 2.82479C11.1724 2.75884 11.2785 2.72314 11.3876 2.72314C11.4968 2.72314 11.6029 2.75884 11.6898 2.82479C11.7768 2.89074 11.8397 2.98331 11.8691 3.08839L13.4501 9.22339C13.5394 9.56947 13.7198 9.88529 13.9725 10.138C14.2252 10.3907 14.5411 10.5711 14.8871 10.6604L21.0221 12.2414C21.1276 12.2705 21.2207 12.3334 21.287 12.4205C21.3533 12.5075 21.3892 12.614 21.3892 12.7234C21.3892 12.8328 21.3533 12.9392 21.287 13.0263C21.2207 13.1134 21.1276 13.1763 21.0221 13.2054L14.8871 14.7864C14.5411 14.8757 14.2252 15.0561 13.9725 15.3088C13.7198 15.5615 13.5394 15.8773 13.4501 16.2234L11.8681 22.3584C11.8387 22.4635 11.7758 22.5561 11.6888 22.622C11.6019 22.6879 11.4958 22.7236 11.3866 22.7236C11.2775 22.7236 11.1714 22.6879 11.0845 22.622C10.9975 22.5561 10.9346 22.4635 10.9051 22.3584L9.32415 16.2234Z"
      stroke="currentColor"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M19.3887 3.72363V7.72363"
      stroke="currentColor"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M21.3877 5.72314H17.3877"
      stroke="currentColor"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M3.38672 17.7231V19.7231"
      stroke="currentColor"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M4.3877 18.7236H2.3877"
      stroke="currentColor"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);

export default IndexTypeIcon;
